import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import InternalTicketForm from './InternalTicketFrom/InternalTicketForm';
import TicketForm from './TicketForm/TicketForm';
import { AdminLayout } from 'src/Layouts';
import { CANCEL, CREATE_INTERNAL_TICKET, CREATE_TICKET, START_CLAIM, TYPE_CONTACT } from 'src/Utils';
import { Container, Title, HeaderContainer, HeaderContent, ButtonsContainer, CustomButton } from './styles';
var CreateTicket = function (_a) {
    var isInternal = _a.isInternal;
    var history = useHistory();
    var location = useLocation();
    var searchParams = new URLSearchParams(location.search);
    var buildingId = searchParams.get('building_id');
    var isContact = Cookies.get('User') === TYPE_CONTACT;
    var _b = useState(false), isCreateDisabled = _b[0], setIsCreateDisabled = _b[1];
    var ticketActionLabel = isInternal
        ? CREATE_INTERNAL_TICKET
        : isContact
            ? START_CLAIM
            : CREATE_TICKET;
    var handleCancel = function () {
        history.goBack();
    };
    var buildingIdNumber = buildingId != null ? Number(buildingId) : null;
    return (React.createElement(AdminLayout, null,
        React.createElement(Container, null,
            React.createElement(HeaderContainer, null,
                React.createElement(HeaderContent, null,
                    React.createElement(Title, null, ticketActionLabel))),
            isInternal ? (React.createElement(InternalTicketForm, { buildingId: buildingIdNumber, onSubmittingChange: setIsCreateDisabled })) : (React.createElement(TicketForm, { buildingId: buildingIdNumber, onSubmittingChange: setIsCreateDisabled })),
            React.createElement(ButtonsContainer, null,
                React.createElement(CustomButton, { variant: "secondary", onClick: handleCancel }, CANCEL),
                React.createElement(CustomButton, { variant: "primary", type: "submit", form: isInternal ? 'internal-ticket-form' : 'ticket-form', disabled: isCreateDisabled }, ticketActionLabel)))));
};
export default CreateTicket;
